export const AppNavigationActions = {
    SETUP_HELP: "SETUP_HELP",
    OPEN_HELP: "OPEN_HELP",
    CLOSE_HELP: "CLOSE_HELP",
    ERROR_COL: "ERROR_COL",
    RESET_COL: "RESET_COL",
    CLOSE_ON_BACK: "CLOSE_ON_BACK",
    ON_BACK_DEFAULT: "ON_BACK_DEFAULT"
};


// WEBPACK FOOTER //
// ./src/components/appNavigation/actions/AppNavigationActions.js